// extracted by mini-css-extract-plugin
module.exports = {"section":"glossary_section__3VOQ_","glossaryBox":"glossary_glossaryBox__1Wbew","title":"glossary_title__1ZN7b","emoStarDivider":"glossary_emoStarDivider__2pFBv"};